module.exports = __webpack_public_path__ + "static/media/look-after.29e02750.png";